<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">加入班级</p>
				</div>
				<div class="add_class_tip cl_yel mat15">
					<p class="f16px">温馨提示：</p>
					<p>1. 请选择您所教的班级，并且选择您在该班担任的职务（班主任、学科老师）。</p>
					<p>2. 同一个老师在同一个班中可以同时担任 班主任 和 学科老师，因此可以选择多个职务。</p>
					<p>3. 同一个老师可以同时教多个班，因此可以加入多个班。</p>
					<p>4. 同一个老师可以同时教多个年级的班，因此可以加入多个年级的多个班。</p>
					<p>5. 如果在下列班级中找不到自己所教的班级，您可以自己创建行政班或者 致电 {{public.web_phone}} 获取帮助。</p>
				</div>
				<div class="join_nav f18px mat30">
					<div class="join_nav_list cur" v-for="(item,index) in grade" :key="index" :class="{'on':item.gradeId == grade_cur.gradeId}"
					 @click="joinNav(index)">{{item.gradeName}}</div>
				</div>
				<div class="join_cont radius8" v-if="class_list.length > 0">
					<div class="cur join_list" v-for="(item,index) in class_list" :key="index">
						<el-popover placement="bottom" width="740" trigger="click" v-model="item.subject_show" @show="show(index)">
						  <div class="join_list_hide">
								<div class="join_list_hide_header cl_gray">请选择您在 {{item.name}} 担任的职务，可多选。</div>
								<div class="join_list_hide_nav f16px mat15" v-if="subject.length > 0">
									<div class="join_list_hide_list cur" v-for="(subject,subjectIndex) in subject" :key="subjectIndex">
										<el-tooltip placement="top" v-if="subject.is_undertake == 1 && subject.is_oneself_undertake == 0">
										  <div slot="content">该职位已被 {{subject.techar_name}} 担任</div>
										  <el-button class="cl_gray f16px">{{subject.subjectName}}</el-button>
										</el-tooltip>
										<span v-else class="join_list_hide_item inline radius8" :class="[{'on': subject.check}]"
										 @click="check(index,subjectIndex)">{{subject.subjectName}}</span>
									</div>
								</div>
								<div class="join_list_hide_btm tc mat15">
									<button class="join_list_hide_btm_cancel cl_violet radius8 f16px" @click="hide(index)">取消</button>
									<button class="join_list_hide_btm_confirm cl_white radius8 f16px" @click="subjectConfirm(index)">确定</button>
								</div>
							</div>
						  <el-button slot="reference" class="f16px cl_dark radius8 join_list_btn" :class="{'on': item.is_class_undertake==1}"
							 @click="getSubject(item.id)">{{item.name}}</el-button>
						</el-popover>
					</div>
				</div>
				<div class="join_empty tc radius8 f18px cl_gray" v-if="class_list.length == 0">
					<p>该年段暂时没有班级</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'class_join',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 1,
					listCur: 0,
					open: 0,
				},
				grade: [],
				grade_cur: {},
				class_list: [],
				class_cur: {},
				subject: [],
			}
		},
		created() {
			
		},
		mounted() {
			this.getGrade();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			getGrade () {
				this.$get("/api/teacher/get_school_grade_data",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.grade = res.data;
					this.grade_cur = this.grade[0];
					this.getClass();
				});
			},
			getClass () {
				this.$get("/api/teacher/get_grade_class_data",{
					token: localStorage.getItem("token"),
					grade_id: this.grade_cur.gradeId,
				})
				.then(res => {
					if (res.data.length > 0) {
						for (let i = 0; i < res.data.length; i++) {
							res.data[i].subject_show = false;
						}
					}
					this.class_list = res.data;
				});
			},
			getSubject (e) {
				this.$get("/api/teacher/get_class_teacher_data",{
					token: localStorage.getItem("token"),
					class_id: e,
				})
				.then(res => {
					for (let j = 0; j < res.data.length; j++) {
						if (res.data[j].is_undertake == 1 && res.data[j].is_oneself_undertake == 1) {
							res.data[j].check = true;
						} else {
							res.data[j].check = false;
						}
					}
					this.subject = res.data;
				});
			},
			joinNav (e) {
				this.grade_cur = this.grade[e];
				this.getClass();
			},
			show (e) {
				this.class_cur = this.class_list[e];
				this.getSubject(this.class_cur.id);
			},
			hide (e) {
				this.class_list[e].subject_show = false;
				this.subject = [];
			},
			//选择
			check (index,subjectIndex) {
				var subject = this.subject;
				if (subject[subjectIndex].check == true) {
					subject[subjectIndex].check = false;
				} else {
					subject[subjectIndex].check = true;
				}
			},
			//确认
			subjectConfirm (e) {
				var ids = [];
				for (let i =0; i < this.subject.length; i++) {
					if (this.subject[i].check == true) {
						ids.push(this.subject[i].subjectId);
					}
				}
				ids = ids.join(",");
				this.$get("/api/teacher/post_join_class",{
					token: localStorage.getItem("token"),
					class_id: this.class_cur.id,
					subject_ids: ids,
				})
				.then(res => {
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					this.subject = res.data;
					this.class_list[e].subject_show = false;
					if (ids == "") {
						this.class_list[e].is_class_undertake = 0;
					} else {
						this.class_list[e].is_class_undertake = 1;
					}
				});
			},
		},
	}
</script>

<style>
</style>
